var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-warpper"},[_vm._v("Copyright 2021 ©三间有暖平台.All rights reserved.")])}
var staticRenderFns = []

export { render, staticRenderFns }